import { useAxiosRequest } from "api/axiosRequest"
import { BASE_URL } from "api/url_helper"
import { VesselPosition } from "modules/Prevetting/hooks/usePrevetAPI"
import { useState } from "react"

export interface TrackVesselStruct {
  imo: string
  name: string
  loading: string | null
  draft: number | null
  status: string | null
  live_speed: number | null
  h24: number | null
  h48: number | null
  h72: number | null
  avg_speed_6m: number | null
  received: number | null
  vesselPosition: VesselPosition[]
}

export function useTrackVessel() {
  const [trackVesselDetails, setTrackVesselDetails] = useState<
    TrackVesselStruct[] | undefined
  >([])

  const [isTrackVesselLoading, setIsTrackVesselLoading] =
    useState<boolean>(false)
  const clearTrackVesselDetails = () => {
    setTrackVesselDetails([])
    setIsTrackVesselLoading(false)
  }
  const request = useAxiosRequest()
  const trackVessel = async (imos: string[]) => {
    setIsTrackVesselLoading(true)
    try {
      const result = await request<any, TrackVesselStruct[]>({
        url: `${BASE_URL}/vesseltracking/track`,
        params: { imo: imos },
        method: "GET",
      }).then((response) => response?.data)
      setTrackVesselDetails(result)
    } catch (err: unknown) {
      const message = "failed to track vessels"
      console.error(message, err)
      throw err
    } finally {
      setIsTrackVesselLoading(false)
    }
  }
  return {
    trackVesselDetails,
    trackVessel,
    isTrackVesselLoading,
    clearTrackVesselDetails,
  }
}
